import Clinic from "models/clinic";
import { normalizePostalCode } from "./format";

export const getClinicAddress = (clinic: Clinic): string => {
    const parts: string[] = [];

    if (clinic.street) {
        parts.push(clinic.street);
    }
    if (clinic.suite) {
        parts.push(clinic.suite);
    }
    if (clinic.city) {
        parts.push(clinic.city);
    }

    const postalCode = normalizePostalCode(clinic.postalCode);
    const provinceAndPostalCode = [clinic.province, postalCode]
        .filter(Boolean)
        .join(" ");
    if (provinceAndPostalCode) {
        parts.push(provinceAndPostalCode);
    }

    return parts.join(", ");
};

export const getClinicDirectionsDetails = (
    clinic: Clinic,
    language: string
): string | null => {
    const primary =
        language === "fr"
            ? clinic.directionsDetailsFr
            : clinic.directionsDetailsEn;
    const fallback =
        language === "fr"
            ? clinic.directionsDetailsEn
            : clinic.directionsDetailsFr;
    const trimmed = primary?.trim() || fallback?.trim();
    return trimmed ? trimmed : null;
};

export const getClinicMapsHref = (clinic: Clinic): string => {
    if (clinic.googleMapsLink) {
        return clinic.googleMapsLink;
    }

    const address = getClinicAddress(clinic);
    return `https://www.google.com/maps/search/${encodeURIComponent(address)}`;
};

export const hasClinicEntryInstructions = (clinic: Clinic): boolean => {
    return !!(
        clinic.clinicImage?.trim() ||
        clinic.directionsDetailsEn?.trim() ||
        clinic.directionsDetailsFr?.trim()
    );
};

export const hasClinicDoorCode = (clinic: Clinic): boolean => {
    const raw = clinic.code;
    if (raw == null || raw === "") {
        return false;
    }
    return String(raw).trim().toLowerCase() !== "n/a";
};

export const getClinicDoorCodeDisplay = (clinic: Clinic): string =>
    String(clinic.code);
